import { tw } from '@/lib/utils'

import { fillLabel } from './fill-label'
import { StarRatingInput } from './star-rating'

export interface RatingPromptLabels {
  rateThisProduct: string
  chooseRating: string
  ratingOutOf5: string
  writeYourReview: string
  updateYourReview: string
  loadingReviewForm: string
}

interface Props {
  value: number
  onChange: (score: number) => void
  onContinue: () => void
  busy: boolean
  hasExistingReview: boolean
  errorMessage?: string
  labels: RatingPromptLabels
}

export const RatingPrompt = ({ value, onChange, onContinue, busy, hasExistingReview, errorMessage, labels }: Props) => {
  const rated = value > 0

  return (
    <div className="rounded-2xl border border-navy-20 p-6">
      <h3 className="text-[20px] font-medium text-navy">{labels.rateThisProduct}</h3>
      <StarRatingInput
        className="mt-3 -ml-1"
        value={value}
        onChange={onChange}
        label={labels.rateThisProduct}
        optionLabel={(stars) => fillLabel(labels.ratingOutOf5, { score: stars })}
      />
      <p className="mt-1 text-[14px] text-navy-80" aria-live="polite">
        {rated ? fillLabel(labels.ratingOutOf5, { score: value }) : labels.chooseRating}
      </p>
      {errorMessage && (
        <p role="alert" className="mt-4 text-[16px] text-navy">
          {errorMessage}
        </p>
      )}
      <button
        type="button"
        data-tracking="ignore"
        disabled={!rated || busy}
        aria-busy={busy || undefined}
        onClick={onContinue}
        className={tw(
          'mt-5 inline-flex min-h-[48px] w-full items-center justify-center rounded-full px-6 text-[16px] font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lapis sm:w-auto',
          rated ? 'cursor-pointer bg-lapis text-white hover:bg-lapis/90' : 'cursor-not-allowed bg-navy-5 text-navy-40'
        )}
      >
        {busy ? labels.loadingReviewForm : hasExistingReview ? labels.updateYourReview : labels.writeYourReview}
      </button>
    </div>
  )
}
